import UserService from "@/services/modules/userService";
import { authMixin } from "@/mixins/authMixin";

export default {
  name: "language-selection",
  mixins: [authMixin],
  data() {
    return {
      showDialog: false,
      selectedLang: this.$i18n.locale,
      languageList: [
        {
          title: this.$t("languages.farsi"),
          value: "fa"
        },
        {
          title: this.$t("languages.english"),
          value: "en"
        }
        // {
        //   title: this.$t("languages.arabic"),
        //   value: "ar"
        // }
      ]
    };
  },

  // computed: {
  //   showSelected() {
  //     return this.languageList.find((item) => item.value == this.selectedLang);
  //   },
  // },

  methods: {
    async confirm(lang) {
      const newLang = lang.value;
      const currentLang = this.$cookies.get("lang");

      if (currentLang === newLang) {
        console.log("[Lang] No change, skipping update.");
        return;
      }

      const prevQuery = { ...this.$route.query };
      this.$router
        .replace({ query: { ...prevQuery, lang: newLang } })
        .catch(() => {});

      this.$cookies.set("lang", newLang);

      this.applyLanguage(newLang);

      if (this.isAuth) {
        try {
          await this.setUserAccountSettings({ language: newLang });
          window.location.reload();
        } catch (err) {
          console.error("[Lang] Failed to update user language:", err);
        }
      } else {
        this.$cookies.set("userChangeSetting", true);
      }

      console.info(`[Lang] Changed to ${newLang}`);
    },
    async updateUserLanguage(lang) {
      try {
        await this.setUserAccountSettings({ language: lang });
        window.location.reload();
      } catch (err) {
        console.error("[Lang] Failed to update user language:", err);
      }
    },

    applyLanguage(lang) {
      const isEnglish = lang === "en";
      const direction = isEnglish ? "ltr" : "rtl";

      this.$vuetify.rtl = !isEnglish;
      this.$i18n.locale = lang;

      localStorage.setItem("lang", lang);
      localStorage.setItem("direction", direction);
    },
    setUserAccountSettings(payload) {
      return UserService.saveUserAccountSetting(payload);
    }
  }
};
